import { render, staticRenderFns } from "./ContactSubmission.vue?vue&type=template&id=ff1ad2da&"
import script from "./ContactSubmission.vue?vue&type=script&lang=js&"
export * from "./ContactSubmission.vue?vue&type=script&lang=js&"
import style0 from "./ContactSubmission.vue?vue&type=style&index=0&id=ff1ad2da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports